import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "../ThemeToggle";

const resume = require("../../assets/data/resume.pdf");

export const Arrow = ({ diagonal = false }: { diagonal?: boolean }) => (
  <span aria-hidden="true" className="arrow-icon">
    <svg viewBox="0 0 24 24" focusable="false">
      {diagonal ? <path d="M4 20 20 4M7 4h13v13" /> : <path d="M3 12h17m-6-6 6 6-6 6" />}
    </svg>
  </span>
);

export const Spark = ({ className = "" }: { className?: string }) => (
  <span aria-hidden="true" className={`spark-icon ${className}`}>
    <svg viewBox="0 0 24 24" focusable="false">
      <polygon points="12,1 13.72,7.84 19.78,4.22 16.16,10.28 23,12 16.16,13.72 19.78,19.78 13.72,16.16 12,23 10.28,16.16 4.22,19.78 7.84,13.72 1,12 7.84,10.28 4.22,4.22 10.28,7.84" />
    </svg>
  </span>
);

export const Header = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(() => window.scrollY > 12);
  const brandLabel = pathname === "/"
    ? "Alexandre Toubiana, top of page"
    : pathname === "/atelier"
      ? "Alexandre Toubiana, portfolio — back to portfolio"
      : "Alexandre Toubiana — back to portfolio";

  useEffect(() => {
    const updateScrollState = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", updateScrollState, { passive: true });
    updateScrollState();
    return () => window.removeEventListener("scroll", updateScrollState);
  }, []);

  return (
  <header className={`site-header${scrolled ? " site-header--scrolled" : ""}`}>
    <Link className="site-brand" to="/" aria-label={brandLabel}>AT<span className="brand-period">.</span></Link>
    <nav aria-label="Main navigation" className="site-nav">
      <Link to="/#experience">Experience</Link>
      <Link to="/#projects">Projects</Link>
      <Link to="/#about">About</Link>
    </nav>
    <ThemeToggle />
    <Link className="header-contact" to="/contact" aria-label="Contact Alexandre"><span className="header-contact-label">Contact</span><Arrow diagonal /></Link>
  </header>
  );
};

export const Footer = () => (
  <footer className="site-footer">
    <div className="footer-top"><span>Want to say hello?</span><Link to="/contact">Contact me <Arrow diagonal /></Link></div>
    <div className="footer-bottom">
      <a href="#top" className="footer-signature">Alexandre Toubiana<span className="brand-period">.</span></a>
      <div className="footer-links"><Link className="footer-atelier" to="/atelier">Atelier <Arrow diagonal /></Link><a href={resume} target="_blank" rel="noreferrer">Résumé</a><a href="https://x.com/alex_toubiana" target="_blank" rel="noreferrer">X</a><a href="https://github.com/alextoub" target="_blank" rel="noreferrer">GitHub</a><a href="https://www.linkedin.com/in/alexandre-toubiana" target="_blank" rel="noreferrer">LinkedIn</a></div>
      <span>© {new Date().getFullYear()}</span>
    </div>
  </footer>
);
